import { render, staticRenderFns } from "./ScheduleNewVacation.vue?vue&type=template&id=167524a2&scoped=true"
import script from "./ScheduleNewVacation.vue?vue&type=script&lang=ts"
export * from "./ScheduleNewVacation.vue?vue&type=script&lang=ts"
import style0 from "./ScheduleNewVacation.vue?vue&type=style&index=0&id=167524a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167524a2",
  null
  
)

export default component.exports